import { useCallback, useEffect, useState } from "react";
import type { UseTraversingState } from "./types";

export const useTraversingState: UseTraversingState = ({
  subscribeOnReset,
}) => {
  const [isTraversing, setIsTraversing] = useState(false);

  const startTraversing = useCallback(() => setIsTraversing(true), []);
  const stopTraversing = useCallback(() => setIsTraversing(false), []);

  useEffect(
    () => subscribeOnReset(stopTraversing),
    [subscribeOnReset, stopTraversing],
  );

  return { isTraversing, startTraversing, stopTraversing };
};
